<template>
    <div class="bzj_sm">
        <van-icon name="cross" class="cross" @click="close"/>
        <div class="tit">服务费说明</div>
        <p>为保障交易安全，提供高效的寄售服务平台将对成功交易的道具收取少量服务费。具体规则如下:</p>
        <table>
            <tr>
                <th>道具分类</th>
                <th>费率</th>
            </tr>
            <tr v-for="(item,i) in rateList" :key="i">
                <td>{{ item.prop_name }}</td>
                <td>{{ item.rate }}%</td>
            </tr>
        </table>
        <p>注:无特殊说明道具，均按常规道具费率计算。实际费率以出售时显示为准。</p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                rateList: this.selection.rateList
            }
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            close() {
                this.$emit('closeModal')
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .bzj_sm {
        padding: 1.8rem 2.5rem;
        .cross {
            position: absolute;
            right: 1.1rem;
            top: 1.2rem;
            font-size: 1.8rem;
            color: #000;
            cursor: pointer;
        }
        .tit {
            font-size: 1.6rem;
            color: #F66F30;
            font-weight: 700;
            margin-bottom: 2rem;
            text-align: center;
        }

        p {
            font-size: 1.4rem;
            color: #555;
            line-height: 1.5;
        }
        table {
            margin: 1.2rem 0 1.4rem;
            border-collapse: collapse;
            border-color: #a4a4a4;
            th,td {
                border: 1px solid #a4a4a4;
                text-align: center;
                height: 2.5rem;
                color: #000;
                font-size: 1.4rem;
                &:nth-child(1) {
                    width: 12.6rem;
                }
                &:nth-child(2) {
                    width: 11.5rem;
                }
            }
        }
    }
</style>
